import router from "./router";
import i18n from "./i18n";

export const errorModuleRouter = router;
export const errorModuleI18n = i18n;
